import R from 'ramda';
import { createAction } from 'redux-actions';
import reportError from 'ha/helpers/bugsnag/reportError';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import { Actions, DefaultRadius } from '../constants';
import { getCitiesNearbyRequestId, getPreviousParams } from '../selectors';

const queryParams = ['citySearch', 'cityMinPopulation', 'cityMinRooms'];

const flow = {
  start: createAction(Actions.LOAD_CITIES_NEARBY_START),
  done: createAction(Actions.LOAD_CITIES_NEARBY_DONE),
};

export default reqParams => (dispatch, getState, services) => {
  const state = getState();
  const previousParams = R.pick(queryParams, getPreviousParams(state));

  if (R.equals(R.pick(queryParams, reqParams), previousParams)) {
    return Promise.resolve();
  }

  const params = {
    query: reqParams.citySearch,
    minListings: reqParams.cityMinRooms,
    minPopulation: reqParams.cityMinPopulation,
    lang: getCurrentLanguageCode(state),
    radius: DefaultRadius,
    excludeQuery: true,
  };

  const requestId = Date.now();

  dispatch(flow.start(requestId));

  return services.apiV2
    .getCitiesNearby(params)
    .then(response => {
      if (getCitiesNearbyRequestId(getState()) !== requestId) {
        // Query is not the last one. Dismiss results.
        return;
      }

      dispatch(flow.done(response.data.cities));
    })
    .catch(error => {
      reportError(error);
      dispatch(flow.done([]));
    });
};
